type InitOptions = {
    chatId: string;
    product: AnimatronProduct;
    welcomeMessageAppearance?: string;
    useDefaultLauncher?: boolean;
};
let initCompleted: Promise<InitOptions>;
const init = (settings: InitOptions) => {
    initCompleted = new Promise(resolve =>
        resolve({ welcomeMessageAppearance: 'hidden', useDefaultLauncher: true, ...settings })
    );
};

declare global {
    interface Window {
        FrontChat: any;
    }
}

const waitFor = (check: () => boolean, limit = 10, name = 'waitFor') =>
    new Promise((resolve, reject) => {
        let count = 0;

        const run = () => {
            if (check()) {
                resolve('OK');
            } else if (count > limit) {
                reject(`${name}: call limit reached`);
            } else {
                count = count + 1;
                setTimeout(() => run(), 100);
            }
        };
        run();
    });

export const frontChat = (...a: any[]) => {
    waitFor(() => !!window.FrontChat, 50, 'wait for FrontChat loaded').then(() => {
        window.FrontChat && window.FrontChat(...a);
    });
};

const initFrontChat = async (newSettings: { [key: string]: any }) => {
    initCompleted.then(settings => {
        frontChat('shutdown', { clearSession: true });
        setTimeout(
            () =>
                frontChat('init', {
                    ...settings,
                    ...newSettings
                }),
            0
        );
    });
};

function setUser({
    displayName,
    email,
    username,
    userIdAsString,
    meta: { frontStudioHash },
    subscriptionDetails
}: anm.User) {
    if (!userIdAsString) return;
    initFrontChat({
        name: displayName,
        userHash: frontStudioHash,
        userId: userIdAsString,
        contact: {
            email,
            customFields: {
                Username: username,
                Admin: `https://webadmin.animatron${
                    options.isProduction ? '' : '-test'
                }.com/admin/user.html?userId=${userIdAsString}`,
                'Studio Plan': subscriptionDetails.studio.name,
                'Wave Plan': subscriptionDetails.wave.name
            }
        }
    });
}

function setAnonymous() {
    initFrontChat({
        name: 'Guest'
    });
}

function show() {
    initCompleted.then(() => {
        frontChat('show');
    });
}

function hide() {
    initCompleted.then(() => {
        frontChat('hide');
    });
}

function unreadCountChange(cb: (n: number) => void) {
    initCompleted.then(() => {
        frontChat('onUnreadChange', cb);
    });
}

export default {
    init,
    setUser,
    setAnonymous,
    show,
    hide,
    unreadCountChange
};



// WEBPACK FOOTER //
// ./app/assets/javascripts/frontChat.ts